<template>
  <div class="flex">
    <div class="color mr-5" :style="{ backgroundColor: color }" />
    <div class="flex flex-column chart-legend">
      <h4 class="mt-0">
        {{ label }}: <strong>{{ percentage }}%</strong>
      </h4>
      <p class="flex flex-wrap">
        <template v-for="{ FK_skillKey, points } in linkedSkills">
          <span
            class="skill-text"
            :key="`skill-${FK_skillKey}`"
            :class="['m-0 mr-5 mb-5 info-box', points >= 0 ? 'bg-success' : 'bg-danger']"
            v-if="points"
          >
            {{ skills[FK_skillKey].name }}: {{ points | formatScore }}
          </span>
        </template>
      </p>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      color: {
        type: String,
        required: true,
      },
      label: {
        type: String,
      },

      percentage: {
        type: Number,
      },
      linkedSkills: {
        type: [Object, Array],
        required: true,
      },
    },

    computed: {
      ...mapState('editMode/skills', ['skills']),
    },
  };
</script>

<style lang="scss" scoped>
  .chart-legend {
    width: calc(100% - 30px);
  }

  .color {
    width: 30px;
    height: 20px;
  }

  .skill-text {
    color: #666;
    font-size: smaller;
  }
</style>
